const config = {
    server: {
        url: "https://marketplaceapi.zocial.io",
        zocialServerUrl: "https://api.zocial.io",
    },
    imageBaseUrl: "https://image.zocial.io/marketplace",
    videoBaseUrl: "https:/video1.zocial.io/marketplace",
    stripeConnectUrl: "https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_ItSqEFyvMr5MHhOqa0TpiCguSD249lQ6&scope=read_write",
    locationApiKey: "AIzaSyDBL7AsC5ka72_TCrTxJFYcAxKWUSmIf9o",
    staticToken: "Ho3V1ibfZHIcykIhy9RpZJ2IFOkwBwVlzb1PXDlZO8rNC2GJsWW0ZBmh1NQi34mi",
    clubs: {
        sanjose: "65c1c987-efcc-4c5f-8f29-04157daa2e36",
        fremont: "dd32a579-8058-4e6a-92c2-4271aa58bd39",
        colorado: "7a673cb5-e965-42a9-8614-00edb1d81f8a"
    },
    flatFeePerTransaction: 0.75,
    flatFeeForConnectedUser: 0
};
export default config;